import { POST_ENTERPRISES_START } from '../../types';

export const post_enterprises = (payload) => ({
  type: POST_ENTERPRISES_START,
  payload,
});
